import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';

export const RecommendBorderIcon = ({
  color = Color.Gray700,
  opacity = 1.0,
  className = 'size-[24px]',
}: NewIconProps) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    opacity={opacity}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.64 13.47C21.64 13.05 21.57 12.65 21.43 12.27C21.57 11.89 21.64 11.49 21.64 11.07C21.64 9.13 20.06 7.55 18.12 7.55L16.22 7.53C16.24 7 16.24 6.64 16.24 6.61V6.58V6.55C16.24 4.56 14.92 2.4 12.78 2.4H12.08C10.99 2.46 9.73 3.18 9.48 5.01C9.41 5.5 9.32 6.13 9.29 6.27L9.26 6.37V6.39C9.26 6.39 8.98 7.78 7.75 9.5C7.65 9.46 7.54 9.43 7.42 9.43H3.3C2.75 9.43 2.3 9.88 2.3 10.43V20.46C2.3 21.01 2.75 21.46 3.3 21.46H7.43C7.86 21.46 8.22 21.18 8.36 20.8C8.92 21.12 9.57 21.3 10.25 21.3H16.47C18.28 21.3 19.77 19.93 19.96 18.17C20.65 17.52 21.07 16.61 21.07 15.6C21.07 15.53 21.07 15.47 21.07 15.4C21.44 14.84 21.65 14.17 21.65 13.47H21.64ZM6.43 19.45H4.3V11.42H6.43V19.45ZM18.84 14.8C18.99 15.04 19.07 15.31 19.07 15.59C19.07 16.34 18.53 16.96 17.81 17.08C17.92 17.29 17.98 17.52 17.98 17.77C17.98 18.61 17.3 19.29 16.46 19.29H10.24C9.39 19.29 8.64 18.71 8.43 17.88C8.43 17.84 8.42 17.8 8.42 17.76V12.63C8.42 12.63 8.42 12.58 8.42 12.55C8.43 11.99 8.74 11.54 9.24 10.83C10.92 8.56 11.23 6.69 11.23 6.69C11.28 6.47 11.45 5.26 11.45 5.26C11.52 4.76 11.71 4.4 12.18 4.38H12.77C13.71 4.38 14.23 5.66 14.23 6.55C14.23 6.57 14.23 6.59 14.23 6.6C14.23 6.6 14.23 8.13 14.07 9.49L18.12 9.54C18.96 9.54 19.64 10.22 19.64 11.06C19.64 11.54 19.42 11.98 19.04 12.26C19.41 12.54 19.64 12.98 19.64 13.46C19.64 14.02 19.33 14.53 18.84 14.79V14.8Z"
      fill={color}
    />
  </svg>
);

export const RecommendIcon = ({ className = 'size-[24px]', color = Color.Gray700, opacity = 1.0 }: NewIconProps) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    opacity={opacity}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.63 8.34C15.77 6.9 15.77 5.5 15.77 5.43V5.37C15.77 4.09 15 2.32 13.56 2.32H12.84C12.32 2.35 11.67 2.63 11.51 3.78C11.43 4.36 11.3 5.25 11.25 5.45C11.25 5.47 10.89 7.56 9 10.11C8.41 10.93 7.95 11.58 7.93 12.34V18.55C7.93 18.64 7.94 18.72 7.96 18.81C8.26 20.01 9.34 20.85 10.57 20.85H17.88C19.14 20.85 20.16 19.83 20.16 18.57C20.16 18.4 20.14 18.24 20.11 18.08C20.9 17.71 21.44 16.91 21.44 16C21.44 15.74 21.4 15.48 21.31 15.24C21.82 14.81 22.12 14.18 22.12 13.5C22.12 12.98 21.95 12.49 21.63 12.09C21.95 11.69 22.12 11.19 22.12 10.67C22.12 9.41 21.09 8.39 19.84 8.39L15.63 8.34ZM2.89 10.21H5.96C6.51228 10.21 6.96 10.6577 6.96 11.21V20.68C6.96 21.2323 6.51228 21.68 5.96 21.68H2.89C2.33771 21.68 1.89 21.2323 1.89 20.68V11.21C1.89 10.6577 2.33771 10.21 2.89 10.21Z"
      fill={color}
    />
  </svg>
);
